/* eslint-disable react-hooks/exhaustive-deps */
import useOnScreen from '@Helper/utils';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Checkbox, IconButton, Menu, MenuItem } from '@mui/material';
import { getListTaskCollection } from '@Store/feature/listTaskSlice';
import moment from 'moment';
import React, { FC, useRef, useState } from 'react';

import { Icons } from '../../../assets/SvgIcons';
import { PageType, TaskViewType } from '../../../config/enum';
import { Section } from '../../../config/section';
import { TaskType } from '../../../config/task';
import { ICTask } from '../../../helper/Interfaces';
import {
  getPlayBookDetail,
  postNewTaskVisibleID,
} from '../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import CustomIconButton from '../CustomIconButton/CustomIconButton';
import DetailScore from '../DetailScore/DetailScore';
import EditTextField from '../EditTextField/EditTextField';
import NewTask from '../NewTask/NewTask';
import DeleteDialog, { DeleteType } from '../TodoCard/components/DeleteDialog';
import classes from './SectionCard.module.css';
import { useLocation } from 'react-router-dom';
import { getPersonalTemplatesDetail } from '@Store/feature/personalTemplatesDetailSlice';
import InitialSectionRoad from '../InitialSectionRoad.tsx/InitialSectionRoad';

//Icons
type SectionCardProps = {
  currentSection: Section;
  children?: any;
  taskViewType: TaskViewType;
  setInitialTaskVisible: (newTaskVisible: boolean) => void;
  setSearchLoading?: (loading: boolean) => void;
  setSelectedSectionIds?: (value: React.SetStateAction<string[]>) => void;
  selectedSectionIds?: string[];
  setSelectedTaskIds?: (value: React.SetStateAction<string[]>) => void;
  selectedTaskIds?: string[];
  updateSection: (sectionId: string, sectionName: string) => void;
  deleteSection?: (sectionId: string, moveTasks: boolean) => void;
  archiveSection?: (sectionId: string, isArchived: boolean) => void;
  initialTaskVisible: boolean;
  expandType?: string;
  pageType?: PageType;
  relatedTasks?: ICTask[];
  callRefresh?: () => void;
  dragAndDropButton?: React.ReactNode;
};

const SectionCard: FC<SectionCardProps> = ({
  currentSection,
  children,
  setSearchLoading,
  taskViewType,
  setInitialTaskVisible,
  initialTaskVisible,
  deleteSection,
  updateSection,
  archiveSection,
  pageType,
  expandType,
  setSelectedSectionIds,
  selectedSectionIds,
  setSelectedTaskIds,
  selectedTaskIds,
  relatedTasks,
  callRefresh,
  dragAndDropButton,
}) => {
  const [newTaskVisible, setnewTaskVisible] = useState<boolean>(false);
  const [nameEdit, setNameEdit] = useState<boolean>(false);
  const [expand, setExpand] = useState(true);
  const [sectionName, setSectionName] = useState<string>(currentSection.name);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [checked, setChecked] = useState<boolean>(false);
  const [subTaskCount, setsubTaskCount] = useState(0);
  const taskListCollection = useAppSelector(getListTaskCollection);
  const [endOfList, endOfListRef] = useOnScreen();
  const listRef = useRef(null);

  const [riskCount, setriskCount] = useState(0);
  const [issueCount, setIssueCount] = useState(0);
  const [subDecisionCount, setDecisionCount] = useState(0);
  const prevScrollY = useRef(0);
  const [dependencyCount, setDependencyCount] = useState(0);
  const [maxDueDate, setMaxDueDate] = useState<Date | undefined | any>(
    undefined
  );
  const [blinkDuration, setBlinkDuration] = useState(0);
  const [emptyLength, setEmptyLength] = useState(170);
  const [isEmpty, setIsEmpty] = useState(false);
  const [blockingCorruption, setBlockingCorruption] = useState(false);
  const [goingUp, setGoingUp] = useState(false);
  const { tasks } = useAppSelector(getPersonalTemplatesDetail);

  const location = useLocation();

  let template = false;
  if (location.pathname.split('/')[1] === 'personal-templates-detail') {
    template = true;
  }

  const open = Boolean(anchorEl);
  const sectionRef = useRef(null);
  const openMoreMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeMoreMenu = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [goingUp]);

  const [deleteDialog, setDeleteDialog] = useState(false);
  const { dealTaskList, newTaskVisibleID, sectionList } =
    useAppSelector(getPlayBookDetail);
  const dispatch = useAppDispatch();

  function arrayContains(arr: string[], arr2: string[]) {
    return arr.every(i => arr2.includes(i));
  }

  function findSectionTasksWithSub(sectionId: string, isArchived: boolean) {
    let sectionTask = [] as ICTask[];
    for (const item of dealTaskList.filter(
      t => t.sectionId === sectionId && t.isArchived === isArchived
    )) {
      sectionTask = [
        ...sectionTask,
        ...findChildren(item.id ?? '', isArchived),
      ];
      sectionTask.push(item);
    }
    return sectionTask;
  }

  function findChildren(taskId: string, isArchived: boolean) {
    let childrenTasks = [] as ICTask[];
    for (const item of dealTaskList.filter(
      t => t.parentId === taskId && t.isArchived === isArchived
    )) {
      if (
        dealTaskList.filter(
          t => t.parentId === item.id && t.isArchived === isArchived
        ).length > 0
      ) {
        childrenTasks = [
          ...childrenTasks,
          ...findChildren(item.id ?? '', isArchived),
        ];
      }
      childrenTasks.push(item);
    }
    return childrenTasks;
  }

  React.useEffect(() => {
    if (sectionList?.length === 1 && dealTaskList.length === 0)
      setIsEmpty(true);
    else setIsEmpty(false);
  }, [sectionList, dealTaskList]);

  React.useEffect(() => {
    if (
      currentSection &&
      relatedTasks &&
      !blockingCorruption &&
      expand &&
      endOfList
    ) {
      if (listRef !== null && listRef.current) {
        setEmptyLength((listRef.current as any).clientHeight ?? 0);
      }
    }
  }, [currentSection, listRef, endOfList]);

  React.useEffect(() => {
    setnewTaskVisible(initialTaskVisible);
  }, []);

  React.useEffect(() => {
    setSectionName(currentSection.name);
    if (template) {
      if (
        currentSection &&
        currentSection.id &&
        tasks !== undefined &&
        tasks.length > 0
      ) {
        setsubTaskCount(
          tasks
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.subTaskCount ?? 0),
              0
            )
        );
        setriskCount(
          tasks
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.riskCount ?? 0),
              0
            )
        );
        setIssueCount(
          tasks
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.issueCount ?? 0),
              0
            )
        );
        setDecisionCount(
          tasks
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.decisionCount ?? 0),
              0
            )
        );
        setDependencyCount(
          tasks
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) =>
                sum + (current.dependenciesCount ?? 0),
              0
            )
        );
      }
    } else {
      if (
        currentSection &&
        currentSection.id &&
        dealTaskList !== undefined &&
        dealTaskList.length > 0
      ) {
        setsubTaskCount(
          dealTaskList
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.subTaskCount ?? 0),
              0
            )
        );
        setriskCount(
          dealTaskList
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.riskCount ?? 0),
              0
            )
        );
        setIssueCount(
          dealTaskList
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.issueCount ?? 0),
              0
            )
        );
        setDecisionCount(
          dealTaskList
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) => sum + (current.decisionCount ?? 0),
              0
            )
        );
        setDependencyCount(
          dealTaskList
            .filter(i => i.sectionId === currentSection.id)
            .reduce(
              (sum: any, current: ICTask) =>
                sum + (current.dependenciesCount ?? 0),
              0
            )
        );
        if (pageType !== PageType.ARCHIVE) {
          const elem = findSectionTasksWithSub(currentSection.id, false);
          const maxDate = elem
            .filter(i => i.dueDate)
            .reduce((a: ICTask, b: ICTask) => {
              return (a.dueDate ?? '') > (b.dueDate ?? '') ? a : b;
            }, {});
          setMaxDueDate(
            maxDate.dueDate != null || maxDate.dueDate !== undefined
              ? maxDate.dueDate?.split('T')[0]
              : maxDate.dueDate
          );
        } else {
          const maxDate = dealTaskList
            .filter(
              i =>
                i.sectionId === currentSection.id && i.dueDate && i.isArchived
            )
            .reduce((a: ICTask, b: ICTask) => {
              return (a.dueDate ?? '') > (b.dueDate ?? '') ? a : b;
            }, {});
          setMaxDueDate(
            maxDate.dueDate != null || maxDate.dueDate !== undefined
              ? maxDate.dueDate?.split('T')[0]
              : maxDate.dueDate
          );
        }
      }
    }
  }, [currentSection, dealTaskList, tasks]);

  React.useEffect(() => {
    setChecked(selectedSectionIds?.includes(currentSection.id) ?? false);
  }, [selectedSectionIds]);

  React.useEffect(() => {
    if (
      relatedTasks &&
      selectedTaskIds &&
      selectedSectionIds &&
      setSelectedSectionIds
    ) {
      if (
        arrayContains(
          dealTaskList
            .filter(d => d.sectionId === currentSection.id)
            .map(i => i.id!),
          selectedTaskIds
        )
      ) {
        if (!selectedSectionIds.includes(currentSection.id)) {
          setSelectedSectionIds(old => [...old, currentSection.id]);
        }
      } else {
        setSelectedSectionIds([
          ...selectedSectionIds.filter(i => i !== currentSection.id),
        ]);
      }
    }
  }, [selectedTaskIds, currentSection]);

  React.useEffect(() => {
    setExpand(expandType?.includes('Expand') ?? true);
  }, [expandType]);

  return (
    <div ref={sectionRef}>
      <div
        className={[
          classes.SectionCard,
          taskViewType === TaskViewType.BOARD && classes.SectionCardBoard,
        ].join(' ')}
        id={currentSection.id}
      >
        <div
          className={[
            classes.header,
            taskViewType === TaskViewType.BOARD && classes.headerBoard,
          ].join(' ')}
        >
          <div className={classes.headerLeft}>
            {dragAndDropButton && dragAndDropButton}
            {setSelectedSectionIds && (
              <div>
                <Checkbox
                  sx={{
                    color: '#8B89A4',
                    '&.Mui-checked': {
                      color: '#4C43AA',
                    },
                  }}
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                  checked={checked}
                  onChange={evt => {
                    const taskIdCollection: string[] = [];

                    for (const item of dealTaskList.filter(
                      i => i.sectionId === currentSection.id
                    )) {
                      if (currentSection.isArchived) {
                        taskIdCollection.push(item.id ?? '');
                      } else {
                        if (item.isArchived) {
                          taskIdCollection.push(item.id ?? '');
                        }
                      }
                    }

                    if (evt.target.checked) {
                      if (selectedTaskIds && setSelectedTaskIds) {
                        const newChecked = [...selectedTaskIds];
                        for (const taskId of taskIdCollection) {
                          newChecked.push(taskId);
                        }
                        setSelectedTaskIds([...newChecked]);
                      }
                      setSelectedSectionIds(old => [...old, currentSection.id]);
                    } else {
                      if (selectedTaskIds && setSelectedTaskIds) {
                        setSelectedTaskIds([
                          ...selectedTaskIds.filter(
                            f => !taskIdCollection.includes(f)
                          ),
                        ]);
                      }
                      if (selectedSectionIds)
                        setSelectedSectionIds([
                          ...selectedSectionIds.filter(
                            i => i !== currentSection.id
                          ),
                        ]);
                    }
                  }}
                />
              </div>
            )}
            {taskViewType === TaskViewType.LIST && (
              <IconButton
                aria-label="delete"
                size="small"
                onClick={() => setExpand(!expand)}
              >
                {expand ? (
                  <ArrowDropDownIcon
                    sx={{ color: '#000000' }}
                    fontSize="inherit"
                  />
                ) : (
                  <ArrowRightIcon
                    sx={{ color: '#000000' }}
                    fontSize="inherit"
                  />
                )}
              </IconButton>
            )}
            <div
              className="Headline-6"
              style={{ marginLeft: 10, marginRight: 5 }}
            >
              <EditTextField
                handleClick={() => {}}
                value={sectionName}
                setValue={setSectionName}
                isActive={nameEdit}
                task={currentSection}
                setIsActive={setNameEdit}
                updateSection={updateSection}
                classes={['section-name']}
                editOnClick={true}
                style={
                  pageType &&
                  (pageType === PageType.RISKS ||
                    PageType.ISSUES ||
                    PageType.DECISIONS ||
                    PageType.DEPENDENCIES)
                    ? { fontWeight: 'bold' }
                    : {}
                }
              />
            </div>
            {taskViewType === TaskViewType.BOARD && (
              <IconButton
                aria-label="add"
                size="small"
                onClick={openMoreMenu}
              ></IconButton>
            )}
            {!pageType &&
              pageType !== PageType.MYTASKS &&
              pageType !== PageType.ISSUES &&
              pageType !== PageType.DECISIONS &&
              pageType !== PageType.DEPENDENCIES &&
              pageType !== PageType.RISKS && (
                <>
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      background: 'rgba(127, 119, 217, 0.2',
                      borderRadius: 4,
                      width: expand ? 22 : 'auto',
                      height: expand ? 22 : 'auto',
                    }}
                    onClick={() => {
                      setExpand(true);
                      dispatch(postNewTaskVisibleID(currentSection.id));
                      setnewTaskVisible(true);
                    }}
                  >
                    {expand ? (
                      <Icons.Add height="14px" color="#4C43AA" />
                    ) : (
                      <>
                        {' '}
                        <CustomIconButton
                          title="Add New Task"
                          className={classes.addNewTask}
                          spanClassName={'pl-10'}
                          icon={<Icons.Add color="#ffffff" />}
                          clickHandler={() => {
                            setExpand(true);
                            dispatch(postNewTaskVisibleID(currentSection.id));
                            setnewTaskVisible(true);
                          }}
                        />
                      </>
                    )}
                  </div>
                </>
              )}
          </div>

          <div className={classes.headerRight}>
            {!isEmpty && (
              <>
                <div className={classes.taskCount}>
                  {relatedTasks && (
                    <>
                      (
                      {relatedTasks?.filter(item => item.type === 'milestone')
                        ?.length > 0 &&
                        relatedTasks?.filter(item => item.type === 'milestone')
                          ?.length + ' milestones & '}
                      {relatedTasks?.filter(item => item.type === 'task')
                        ?.length + ' tasks'}
                      )
                    </>
                  )}
                </div>
                <div className={classes.sectionDate}>
                  {maxDueDate
                    ? moment(maxDueDate).format('MM-DD-YYYY')
                    : 'No due date available'}
                </div>
                <DetailScore
                  subTask={subTaskCount}
                  risks={riskCount}
                  decision={subDecisionCount}
                  dependency={dependencyCount}
                  issues={issueCount}
                  small={true}
                  //TODO:extraField={'Section '}
                />
              </>
            )}
            {!pageType &&
              pageType !== PageType.MYTASKS &&
              pageType !== PageType.ISSUES &&
              pageType !== PageType.DECISIONS &&
              pageType !== PageType.DEPENDENCIES &&
              pageType !== PageType.RISKS && (
                <>
                  <IconButton
                    aria-label="delete"
                    size="small"
                    onClick={openMoreMenu}
                  >
                    <MoreHorizIcon />
                  </IconButton>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={closeMoreMenu}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                    PaperProps={{
                      style: {
                        background: '#ffffff',
                        border: ' 1px solid #ebebf0',
                        boxSizing: 'border-box',
                        boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
                        borderRadius: 4,
                        padding: '8px 8px 6px',
                        width: 208,
                      },
                    }}
                  >
                    <MenuItem>
                      <span
                        className="MenuItemRow"
                        onClick={() => {
                          setNameEdit(true);
                          closeMoreMenu();
                        }}
                      >
                        Update Section Name
                      </span>
                    </MenuItem>
                    {!template && (
                      <MenuItem>
                        <span
                          className="MenuItemRow"
                          onClick={() => {
                            if (archiveSection) {
                              archiveSection(currentSection.id, true);
                            }
                          }}
                        >
                          Archive Section
                        </span>
                      </MenuItem>
                    )}

                    <MenuItem>
                      <span
                        className="MenuItemRow"
                        onClick={() => {
                          if (deleteSection) {
                            setDeleteDialog(true);
                          }
                        }}
                      >
                        Delete Section
                      </span>
                    </MenuItem>
                  </Menu>
                </>
              )}
          </div>
        </div>
        <div className={classes.body}>
          {blockingCorruption ? (
            <div
              style={{ height: emptyLength, backgroundColor: 'white' }}
            ></div>
          ) : (
            <>
              {' '}
              {expand ? (
                <div ref={endOfListRef} style={{ marginTop: 15 }}>
                  <div ref={listRef}>
                    {isEmpty ? (
                      <InitialSectionRoad
                        currentSectionId={currentSection.id}
                        setExpand={setExpand}
                        setInitialTaskVisible={setInitialTaskVisible}
                        setIsEmpty={setIsEmpty}
                        setnewTaskVisible={setnewTaskVisible}
                      ></InitialSectionRoad>
                    ) : (
                      children
                    )}
                    <div style={{ marginTop: 15 }}>
                      {newTaskVisible &&
                        newTaskVisibleID === currentSection.id && (
                          <NewTask
                            setnewTaskVisible={setnewTaskVisible}
                            taskType={TaskType.Task}
                            //task={task}
                            section={currentSection}
                            taskViewType={taskViewType}
                            setInitialTaskVisible={setInitialTaskVisible}
                            initialTaskVisible={initialTaskVisible}
                          />
                        )}
                      {!pageType &&
                        pageType !== PageType.MYTASKS &&
                        pageType !== PageType.ISSUES &&
                        pageType !== PageType.ARCHIVE &&
                        pageType !== PageType.DECISIONS &&
                        pageType !== PageType.DEPENDENCIES &&
                        pageType !== PageType.RISKS &&
                        !isEmpty && (
                          <div
                            className={
                              taskViewType === TaskViewType.BOARD
                                ? classes.footer
                                : ''
                            }
                          >
                            <CustomIconButton
                              title="Add New Task"
                              className={classes.addNewTask}
                              spanClassName={'pl-10'}
                              icon={<Icons.Add color="#ffffff" />}
                              clickHandler={() => {
                                setExpand(true);
                                dispatch(
                                  postNewTaskVisibleID(currentSection.id)
                                );
                                setnewTaskVisible(true);
                              }}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
      <DeleteDialog
        deleteAction={() =>
          deleteSection ? deleteSection(currentSection.id, false) : {}
        }
        deleteAndMoveTaskAction={() =>
          deleteSection ? deleteSection(currentSection.id, true) : {}
        }
        sectionId={currentSection.id}
        callRefresh={callRefresh}
        name={currentSection.name ?? ''}
        handleClose={() => {
          setDeleteDialog(false);
          closeMoreMenu();
        }}
        open={deleteDialog}
        subChildrenCount={
          dealTaskList
            ? dealTaskList.filter(i => i.sectionId === currentSection.id).length
            : 0
        }
        type={DeleteType.Section}
      />
    </div>
  );
};

export default SectionCard;
